<div class="rs-dialog">
  <h2 mat-dialog-title class="title">
    Dev Debug
    <span class="right-buttons">
      <button type="button" app-mat-icon-button (click)="onCancel()" matTooltip="Cancel" tabindex="-1">
        <span class="ri-cancel icon-button grey-icon"></span>
      </button>
    </span>
  </h2>

  <div>
    <app-mat-tab-group>
      <app-mat-tab label="TOKEN">
        <div class="scrollable">
          <pre
            class="rs-copy-code-wrapper">{{authInfo?.token}}<app-copy-code class="copy-code-button" [copy]="authInfo?.token"></app-copy-code></pre>
        </div>
      </app-mat-tab>
      <app-mat-tab label="USER">
        <div class="scrollable">
          <pre>{{ user | json }}</pre>
        </div>
      </app-mat-tab>
      <app-mat-tab label="AUTH">
        <div class="scrollable">
          <pre>{{ authInfo | json }}</pre>
        </div>
      </app-mat-tab>
    </app-mat-tab-group>
  </div>
</div>
